import { message as antMessage } from 'antd';

class MessageService {
  constructor() {
    this.message = null;
  }

  setMessage(message) {
    this.message = message;
  }

  success(content, duration, onClose) {
    const config = typeof content === 'object' ? content : { content, duration, onClose };
    if (this.message) {
      this.message.success(config);
    } else {
      antMessage.success(config);
    }
  }

  error(content, duration, onClose) {
    const config = typeof content === 'object' ? content : { content, duration, onClose };
    if (this.message) {
      this.message.error(config);
    } else {
      antMessage.error(config);
    }
  }

  warning(content, duration, onClose) {
    const config = typeof content === 'object' ? content : { content, duration, onClose };
    if (this.message) {
      this.message.warning(config);
    } else {
      antMessage.warning(config);
    }
  }

  info(content, duration, onClose) {
    const config = typeof content === 'object' ? content : { content, duration, onClose };
    if (this.message) {
      this.message.info(config);
    } else {
      antMessage.info(config);
    }
  }

  loading(content, duration, onClose) {
    const config = typeof content === 'object' ? content : { content, duration, onClose };
    if (this.message) {
      return this.message.loading(config);
    } else {
      return antMessage.loading(config);
    }
  }

  destroy(key) {
    if (this.message) {
      this.message.destroy(key);
    } else {
      antMessage.destroy(key);
    }
  }
}

export default new MessageService();
